export const columnDefs = [
  {
    headerName: 'ID',
    field: 'key',
    lockVisible: true,
    lockPosition: true,
    headerClass: 'ag-header-cell-label-left',
    filter: false,
    resizable: false,
  },
  {
    headerName: 'Name',
    field: 'value',
    lockVisible: true,
    lockPosition: true,
    headerClass: 'ag-header-cell-label-left',
    filter: false,
    resizable: false,
  },
];

export const defColumnPreferences = [
  { colId: 'key', hide: false, aggFunc: null, width: 100, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'value', hide: false, aggFunc: null, width: 450, pivotIndex: null, pinned: null, rowGroupIndex: null },
];
